import { render } from "./infoOfProcurement.vue?vue&type=template&id=1fb3710f"
import script from "./infoOfProcurement.vue?vue&type=script&lang=js"
export * from "./infoOfProcurement.vue?vue&type=script&lang=js"

import "./infoOfProcurement.vue?vue&type=style&index=0&id=1fb3710f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__